export const FirebaseConfig = {
	"projectId": "bitfy-mexico",
	"appId": "1:1021642837533:web:b0ee74ac8af473c80b40f4",
	"databaseURL": "https://bitfy-mexico-default-rtdb.firebaseio.com",
	"storageBucket": "bitfy-mexico.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCQaBEIe_KR4HuaFW8jEUckY1uTY0wqkdw",
	"authDomain": "bitfy-mexico.firebaseapp.com",
	"messagingSenderId": "1021642837533",
	"measurementId": "G-9BRCBSS3NX"
};